<template>
  <CCard>
    <CCardBody>

      <BTabs :active-tab.sync="active_tab">

        <BTab :title="$t('CashPayment')">
       <AddPayCash/>
        </BTab>

        <BTab :title="$t('cashListDocsPay')">
          <PayCashList/>
        </BTab>


        <BTab :title="$t('components.cheques')">
        <AddPayCheque/>
        </BTab>


        <BTab :title="$t('chequeListDocsPay')">
<PayChequeList/>
        </BTab>

          <BTab  :title="$t('chequesPayable')">
              <AccountPayable/>
          </BTab>
      </BTabs>

    </CCardBody>

  </CCard>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import BTabs from "../../tabs/BTabs";
import AddPayCash from "./AddPayCash";
import AddPayCheque from "./AddPayCheque";
import PayingOrders from "./PayingOrders";
import PayCashList from "./PayCashList";
import PayChequeList from "./PayChequeList";
import AccountPayable from "../accounting/AccountPayable";
import BTab from "../../tabs/BTab";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
export default {
  name: 'PayOperation',
  components: {
      BTab,
    Treeselect,
    BTabs,
    PayCashList,
    PayChequeList,
    AddPayCash,
    AddPayCheque,
    PayingOrders,
      AccountPayable,

  },

  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      master_id: null,
       master_types: [{id: '1', label: this.$t('factor')}, {id: '2', label: this.$t('debtors')}, {id: '3', label: this.$t('persons')}],
      active_tab: 0,
      search_reference_master: 0,


    }
  }, mounted() {

  }, watch: {

  },
  computed: {

  },
  methods: {

  }
}

</script>
